module.exports = __webpack_public_path__ + "static/cryptocurrency-f98e4d66c48455895ebe7a21d836e2c9.jpg";